<div>
    <nav class="cat__core__top-sidebar cat__core__top-sidebar--bg">

    <span class="cat__core__title d-block mt-2 mb-0 mb-lg-2">
        <strong>Facebook fundraiser: {{fundraiserDisplayName}}</strong>
    </span>
    </nav>
    <div class="nav-tabs-horizontal tab-body facebook-fundraiser-page-body">
        <div class="tab-content">
            <div class="col-lg-5 col-md-12" *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.activeFacebookFundraiserProfiles[0]?.facebookFundraiserId">
                <h3>Manage your fundraising page on Facebook</h3>

                <span class="facebook-fundraiser-goals-block">Go to your Facebook fundraising page to invite friends, share updates, and collect donations - all on Facebook</span>

                We'll keep track of your progress on Facebook and on your {{eventService?.selectedEvent?.label}} page.<br />
                This way you will always know how close you are to reaching your goal.<br />

                <div class="facebook-fundraiser-page-note">
                    Your fundraising totals will always be visible on your LLS fundraising page. Please note that your Facebook page will only show the amount of money raised on Facebook. For total funds, please always refer to your LLS fundraising page.
                </div>

                <div class="facebook-url-input-wrapper">
                    <input type="text"
                           class="form-control facebook-url-input"
                           name="facebookFundraiserUrl"
                           [(ngModel)]="facebookFundraiserUrl"
                           ng-disabled="true"
                           id="facebookFundraiserUrl"
                           disabled="true">
                    <button type="button" class="btn btn-primary facebook-url-copy-btn" (click)="copyFacebookFundraiserUrlToClipboard()">
                        <span *ngIf="!facebookFundraiserUrlCopied">Copy</span>
                        <i class="fa fa-check" *ngIf="facebookFundraiserUrlCopied"></i>
                    </button>
                </div>

                <div class="facebook-f-logo-wrapper">
                    <a><img class="facebook-f-logo" src="assets/img/FB-f-Logo__blue_50.png"/></a>
                    <a (click)="hybridToolsService.openExternalLink(facebookFundraiserUrl)" target="_blank" class="btn btn-primary">
                        View on facebook
                    </a>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 link-facebook-fundraiser-block" *ngIf="!eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.activeFacebookFundraiserProfiles[0]?.facebookFundraiserId">
                <h3>Reach your goal with Facebook</h3>
                <div class="facebook-goal-description">
                    <p>Ready to share on Facebook? You can link your fundraising page to your Facebook account – making it easier than ever to reach your supporters and collect donations for your campaign.</p>

                    <p>Every donation made on your Facebook page is linked directly to your campaign – and your fundraising totals will automatically update on your fundraising page and your Facebook account.</p>

                    <p>Now you can expand your reach for potential donors directly on your social network – enhancing your campaign’s exposure and helping you reach your goal more efficiently.</p>
                </div>

                <ul class="ul-numbered-list">
                    <li>Connect this fundraiser to Facebook</li>
                    <li>Invite friends, share updates, track your progress, and collect donations with Facebook</li>
                    <li>The money you raise on Facebook will count towards your goal</li>
                </ul>
                <facebook-fundraiser-link *ngIf="hybridToolsService.canLinkToFacebook()" [isFacebookFundraiserPage]="true"></facebook-fundraiser-link>
            </div>
        </div>
    </div>
</div>
